module.exports = __webpack_public_path__ + "assets/images/8bc7f407b97bd07f1e1586972d158a00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/portfolio/ansell/ansell-0.jpg
// module id = 813
// module chunks = 0